import {
  SET_FILTERS,
  SET_TABLE_SETTINGS,
  APPLY_PRESET,
  CHANGE_LOCATION,
  SEARCH,
} from '@gogame/screens';

const APPLY = 'APPLY';
const SET_METRICS = 'SET_METRICS';
const SET_DIMENSION = 'SET_DIMENSION';
const SET_SELECTED_IDS = 'SET_SELECTED_IDS';

const SET_ADVANCED_FILTERS = 'SET_ADVANCED_FILTERS';

export {
  SET_SELECTED_IDS,
  SET_FILTERS,
  SET_TABLE_SETTINGS,
  APPLY_PRESET,
  CHANGE_LOCATION,
  APPLY,
  SET_METRICS,
  SET_DIMENSION,
  SEARCH,
  SET_ADVANCED_FILTERS,
};
